import servicoLocalStorage from '@/typescript/servicos/localStorage/localStorage.servico'

export const CHAVE_LOCAL_STORAGE_BARRA_AVISO = 'barra_aviso_usuario_suporte_fechada'

export interface UsuarioBarraAviso {
  ehDeSuporte?: boolean
  email?: string
  id?: string
  compMan?: {
    displayedName?: string
    name?: string
    id?: string
    [key: string]: unknown
  }
  [key: string]: unknown
}

export interface ParametrosAmbienteBarraAviso {
  nodeEnv?: string
  modoProxy?: boolean
  ambienteAlvoProxy?: string
  hostname?: string
  pathname?: string
  href?: string
  userInfo?: UsuarioBarraAviso | null
}

export interface DadosBarraAviso {
  visivel: boolean
  ambiente: string
  empresa: string
  texto: string
}

export function obterNomeDaEmpresa(userInfo?: UsuarioBarraAviso | null): string {
  if (!userInfo?.compMan) return ''
  return userInfo.compMan.displayedName || userInfo.compMan.name || ''
}

export function usuarioEhDeSuporte(userInfo?: UsuarioBarraAviso | null): boolean {
  if (!userInfo) return false
  if (userInfo.ehDeSuporte === true) return true
  if (typeof userInfo.email === 'string') return userInfo.email.includes('lar21@')

  return false
}

export function resolverAmbiente(
  nodeEnv: string = process.env.NODE_ENV || 'development',
  parametrosLocation: { hostname?: string; pathname?: string; href?: string } = {},
  parametrosProxy: { ativo?: boolean; ambienteAlvo?: string } = {}
): { ambiente: string; deveExibirPorAmbiente: boolean; exigeSuporte: boolean } {
  const ambienteAlvoProxy = parametrosProxy.ativo
    ? String(parametrosProxy.ambienteAlvo || '').trim().toLowerCase()
    : ''

  const ehDesenvolvimentoComProxyParaProducao = nodeEnv === 'development'
    && parametrosProxy.ativo
    && ambienteAlvoProxy === 'producao'

  if (ehDesenvolvimentoComProxyParaProducao) {
    return {
      ambiente: 'proxy producao',
      deveExibirPorAmbiente: true,
      exigeSuporte: false,
    }
  }

  const ehProducao = nodeEnv === 'production'

  if (ehProducao) {
    return {
      ambiente: 'producao',
      deveExibirPorAmbiente: true,
      exigeSuporte: true,
    }
  }

  const hostname = parametrosLocation.hostname || ''
  const href = parametrosLocation.href || ''
  const pathname = parametrosLocation.pathname || ''

  const ehHml = hostname.includes('hml.pontotel.com.br') || href.includes('hml.pontotel.com.br')

  if (ehHml) {
    const segmentos = pathname.split('/').filter(Boolean)
    const primeiroPath = segmentos[0] || ''

    if (!primeiroPath || primeiroPath.toLowerCase() === 'pontotel') {
      return {
        ambiente: 'homologacao',
        deveExibirPorAmbiente: true,
        exigeSuporte: false,
      }
    }

    return {
      ambiente: primeiroPath,
      deveExibirPorAmbiente: true,
      exigeSuporte: false,
    }
  }

  return {
    ambiente: 'desenvolvimento',
    deveExibirPorAmbiente: true,
    exigeSuporte: false,
  }
}

export function obterDadosBarraAviso(
  parametros: ParametrosAmbienteBarraAviso = {}
): DadosBarraAviso {
  const {
    nodeEnv = process.env.NODE_ENV || 'development',
    modoProxy = process.env.VUE_APP_MODO_PROXY === 'true',
    ambienteAlvoProxy = process.env.VUE_APP_AMBIENTE,
    hostname,
    pathname,
    href,
    userInfo,
  } = parametros

  const empresa = obterNomeDaEmpresa(userInfo)
  if (!empresa) {
    return {
      visivel: false,
      ambiente: '',
      empresa: '',
      texto: '',
    }
  }

  const { ambiente, deveExibirPorAmbiente, exigeSuporte } = resolverAmbiente(nodeEnv, {
    hostname,
    pathname,
    href,
  }, {
    ativo: modoProxy,
    ambienteAlvo: ambienteAlvoProxy,
  })

  if (!deveExibirPorAmbiente) {
    return {
      visivel: false,
      ambiente: '',
      empresa: '',
      texto: '',
    }
  }

  if (exigeSuporte && !usuarioEhDeSuporte(userInfo)) {
    return {
      visivel: false,
      ambiente,
      empresa,
      texto: '',
    }
  }

  return {
    visivel: true,
    ambiente,
    empresa,
    texto: `${ambiente} - ${empresa}`.toUpperCase(),
  }
}

function sincronizarIdentificadorLocalStorage(userInfo?: UsuarioBarraAviso | null): void {
  const idCompMan = userInfo?.compMan?.id ? String(userInfo.compMan.id) : ''
  const idUsuario = userInfo?.id ? String(userInfo.id) : ''

  if (idCompMan && idUsuario) {
    servicoLocalStorage.definirIdentificador(idCompMan, idUsuario)
  }
}

export function obterEstadoFechadoNoStorage(userInfo?: UsuarioBarraAviso | null): boolean {
  try {
    if (typeof localStorage === 'undefined') return false
    sincronizarIdentificadorLocalStorage(userInfo)
    return servicoLocalStorage.obterItem(CHAVE_LOCAL_STORAGE_BARRA_AVISO) === true
  } catch {
    return false
  }
}

export function salvarEstadoFechadoNoStorage(userInfo?: UsuarioBarraAviso | null): void {
  try {
    if (typeof localStorage === 'undefined') return
    sincronizarIdentificadorLocalStorage(userInfo)
    servicoLocalStorage.salvarItem(CHAVE_LOCAL_STORAGE_BARRA_AVISO, true)
  } catch {
    // Ignora restrições de localStorage ou identificador ausente
  }
}

export function limparEstadoFechadoNoStorage(userInfo?: UsuarioBarraAviso | null): void {
  try {
    if (typeof localStorage === 'undefined') return
    sincronizarIdentificadorLocalStorage(userInfo)
    servicoLocalStorage.removerItem(CHAVE_LOCAL_STORAGE_BARRA_AVISO)
  } catch {
    // Ignora
  }
}
